import { BaseRestDataProvider } from './BaseRestDataProvider';
import { ProductOrService } from '../models/ProductOrService';

export class ProductOrServiceRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/products-and-services');
  }

  getAll(): Promise<ProductOrService[]> {
    return this.get<ProductOrService[]>(``);
  }

  getById(id: string): Promise<ProductOrService> {
    return this.get<ProductOrService>(`/${id}`);
  }

  add(product: ProductOrService): Promise<ProductOrService> {
    return this.post<ProductOrService>(``, product);
  }

  update(id: string, product: ProductOrService): Promise<void> {
    return this.put<void>(`/${id}`, product);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { ProductOrService };
